import { useCallback, useEffect } from 'react'
import { auzdPost } from '../infra/AuthFetcher';
import { useOperatorContext } from '../comps/login/OperatorContextProvider';
import useKiponosNavigator from './useKiponosNavigator';
import { logoutUrl } from '../providers/EnvContextProvider';
import { useTokensContext } from '../providers/TokensContextProvider';
import { useWebSocketContext } from '../providers/WebSocketContextProvider';

export default function useLogout() {
  const {idToken, setIdToken, setAccessToken} = useTokensContext();
  const {isOperatorEject, operatorState, OperatorFlag, dispatchOperatorFlag, setOperator}   = useOperatorContext();    
  const {navTo, PageKeys}                                     = useKiponosNavigator();
  const {wsDisconnect}                                        = useWebSocketContext();

  //
  // ---  Clean Auth  ---
  //
  const cleanAuth = useCallback(() => {
    setOperator(null);
    setIdToken(null);
    setAccessToken(null);    
  }, [setAccessToken, setIdToken, setOperator]);

  //
  // ---  Clean Broswer  ---
  //
  const cleanBrowser = useCallback(() => {
    // Test in Staging (and Production B"H) to make sure it clears!
    // if (!isDevMode()) {
      localStorage.clear();
      sessionStorage.clear();
    // }
  }, []);

  // ---  Clean Connections  ---
  // Disconnect WebSockets
  //
  const cleanConnections = useCallback(() => {
    wsDisconnect();
  }, [wsDisconnect]);
  
  // --- Client Logout ---
  //
  const doClientLogout = useCallback((timoutId) => {
    cleanConnections();
    cleanAuth();
    cleanBrowser();
    setOperator(null);
    clearTimeout(timoutId);
    dispatchOperatorFlag(OperatorFlag.Offline);
  }, [cleanConnections, cleanAuth, cleanBrowser, setOperator, dispatchOperatorFlag, OperatorFlag.Offline]);

  //
  // ---[  Do Logout  ]---
  //
  const doLogout = useCallback( async () => {
    // Give logout a timeout, if not done, try again in a few seconds to eject.  If ok, cancel the timeout.
    const tId = setTimeout(()=>{
      console.error('[useLogout] Unable to complete logout in reasonable time, trying force operator Eject.');
      dispatchOperatorFlag(OperatorFlag.Eject);
    }, 3000);

    return await auzdPost(idToken, logoutUrl)
        .then(result => doClientLogout(tId))
        .catch(err => {
            console.error('Logout ERROR: %s. Please make sure the localStorage is clean!', err);
        }).finally(() => {
          navTo(PageKeys.LOGIN);
          cleanAuth();
          cleanBrowser();
          cleanConnections();
          // Force refresh to clean the browser
          window.location.reload();
        });
  }, [OperatorFlag.Eject, PageKeys.LOGIN, cleanAuth, cleanBrowser, cleanConnections, dispatchOperatorFlag, doClientLogout, idToken, navTo]);

  // On Eject effect
  useEffect(()=>{
    if (isOperatorEject()) {
      console.log('[useLogout] Operator Ejected - doClientLogout');      
      doClientLogout();
    }

    return () => {
      // empty
    }
  }, [operatorState, doClientLogout, isOperatorEject])
  
  // -----  Return  ------
  
  return {
    logout: doLogout
  };
}